import { toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions from '../../../common/flex-options/flex-options.esm.js';
import fontOptions from '../../../common/font-options/font-options.esm.js';
import fieldOptions from '../../../common/field-options/field-options.esm.js';

var inputTV = getTvObject({
  base: [].concat(_toConsumableArray(flexOptions.base), ['bg-base', 'outline-0', 'text-size-inherit', 'text-inherit', 'pl-2', 'pr-8', 'py-1.5', 'h-8', 'rounded-sm', 'gap-1', 'w-full']),
  variants: _objectSpread2(_objectSpread2(_objectSpread2({}, fontOptions), flexOptions.variants), {}, {
    isFocusWithin: fieldOptions.variants.isFocusWithin,
    isInvalid: fieldOptions.variants.isInvalid,
    isDisabled: fieldOptions.variants.isDisabled
  })
});
var base = tv(inputTV);
var inputStyles = {
  base: base
};

export { inputStyles, inputTV };
//# sourceMappingURL=input.styles.esm.js.map
